<template>
  <div class="row">
    <transition name="view" appear enter-active-class="animated fadeInUp delay">
      <div class="col-md-8">
        <edit-profile-form :profile="profile" @update-employees="setProfile">
        </edit-profile-form>
      </div>
    </transition>
      <div class="col-md-4">
        <transition name="view" appear enter-active-class="animated flipInX delay2">
          <div>
            <user-card :profile="profile"></user-card>
            <progress-bar :value="progressValue"></progress-bar>
          </div>
        </transition>
        <transition name="view" appear enter-active-class="animated fadeInUp delay3">
          <password-card :passwords="passwords" @change-password="changePassword" style="margin-top: -15px;"></password-card>
        </transition>
    </div>
  </div>
</template>
<script>
  import {url} from "../plugins/axios";
  import EditProfileForm from './Profile/EditProfileForm';
  import UserCard from './Profile/UserCard'
  import NotificationTemplate from "./Notifications/NotificationTemplate";
  import { BaseAlert } from '@/components';
  import { setCookie } from "../plugins/axios";
  import axios from "axios";
  import PasswordCard from "./Profile/PasswordCard";
  import ProgressBar from "../components/Progress";
  export default {
    components: {
      ProgressBar,
      PasswordCard,
      EditProfileForm,
      UserCard,
      BaseAlert
    },
    data() {
      return {
        profile: {
          user:{id:0,name:'',email:'', description:''},
          employee:{id:0, last_name:'',first_name:'', description:'', phone:'', avatar:'', rate:'', date:''},
          project:{id:0, name:'', address:{street:'', city:'', country:'', code:''}},
          role:{id:0,name:''},
        },
        profileOld: '',
        passwords: {old: '', new: '', conf: ''},
        progressValue:0,
      }
    },
    methods:{
      notifyVue(type,message) {
        this.$notify({
          component: NotificationTemplate,
          icon: "tim-icons icon-bell-55",
          horizontalAlign: 'center',
          verticalAlign: 'top',
          type: type,
          message:message,
          timeout: 1500
        });
      },
      getProfile(){
        axios
          .get(url + 'employees/myself/',
            {
              withCredentials:'include',
              crossDomain:true
            })
          .then((response) => {
            if (response.data.error === 'Session is over'){
              setCookie('Authentication','Failed',1);
              this.$router.push('/login');
            }else{
              let temp = response.data.result[0];
              this.profile.user.id = temp.user_id;
              this.profile.user.name = temp.user_name;
              this.profile.user.email = temp.email;
              this.profile.user.description = temp.userDescription;
              this.profile.employee.id = temp.employee_id;
              this.profile.employee.first_name = temp.first_name;
              this.profile.employee.last_name = temp.last_name;
              this.profile.employee.phone = temp.phone_number;
              this.profile.employee.avatar = temp.avatar_file;
              this.profile.employee.rate = temp.rate_per_hour;
              this.profile.employee.date = temp.creating_date;
              this.profile.employee.description = temp.description;
              this.profile.project.id = temp.project_id;
              this.profile.project.name = temp.full_name;
              this.profile.role.id = temp.type_id;
              this.profile.role.name = temp.name;
              this.profile.project.address = this.setAddress(temp.address);
              this.profileOld = JSON.parse(JSON.stringify(this.profile));
            }
        });
      },
      setProfile(){
        let temp1 = JSON.stringify(this.profileOld);
        let temp2 = JSON.stringify(this.profile);
        if (temp1 === temp2){
          this.notifyVue('info','Data was updated');
        }
        else{
          let data = {};
          if (JSON.stringify(this.profileOld.user) !== JSON.stringify(this.profile.user)){
            data['user'] = {};
            data.user['id'] = this.profile.user.id;
            for( let param in this.profile.user){
              if (this.profile.user[param] !== this.profileOld.user[param]){
                data.user[param] = this.profile.user[param];
              }
            }
          }
          if (JSON.stringify(this.profileOld.employee) !== JSON.stringify(this.profile.employee)){
            data['employee'] = {};
            data.employee['id'] = this.profile.employee.id;
            for( let param in this.profile.employee){
              if (this.profile.employee[param] !== this.profileOld.employee[param]){
                data.employee[param] = this.profile.employee[param];
              }
            }
          }
          axios
            .put(url + 'update-employees/',
              {data: data},
              {
                withCredentials:'include',
                crossDomain:true
              })
            .then((response) => {
              if (response.data.error ===''){
                this.notifyVue('success','Data was updated');
                this.profileOld = JSON.parse(JSON.stringify(this.profile));
              }
              else{
                if (response.data.error === 'Session is over'){
                  setCookie('Authentication','Failed',1);
                  this.$router.push('/login');
                }
                else{
                  this.notifyVue('danger',response.data.error);
                }
              }
            })
            .catch((error) => {
              this.notifyVue('danger',error);
            });
        }
      },
      changePassword(){
        axios
          .put(url + 'change-password/',
            {data:this.passwords},
            {
              withCredentials:'include',
              crossDomain:true
            })
          .then((response) => {
            if (response.data.error === ''){
              this.passwords = {old: '', new: '', conf: ''};
              this.notifyVue('success','Data was updated');
            }else{
              if (response.data.error === 'Session is over'){
                setCookie('Authentication','Failed',1);
                this.$router.push('/login');
              }
              else{
                this.notifyVue('danger',response.data.error);
              }
            }
          }).catch((error) => {
            this.notifyVue('danger',error);
        });
    },
      setAddress(value){
        let address = ['','','',''];
        if ((value==='')||(value===null)){
        }else{
          address = value.split("||");
        }
        let result = {street:'', city:'', country:'',code:''};
        result.street = address[0];
        result.city = address[1];
        result.country = address[2];
        result.code = address[3];
        return result;
      },
    },
    mounted() {
      this.getProfile();
    },
    created: function () {

    },
  }
</script>
<style scoped>
  .delay{
    animation-delay: 1.0s;
  }
  .delay2{
    animation-delay: 2.0s;
  }
  .delay3{
    animation-delay: 2.0s;
  }
</style>
